import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M18.25 5.75v8.5a2 2 0 0 1-2 2H3.75a2 2 0 0 1-2-2v-8.5m16.5 0a2 2 0 0 0-2-2H3.75a2 2 0 0 0-2 2m16.5 0L10 10.5 1.75 5.75"
	})]
});
const ForwardRef = forwardRef(SvgMail);
export { ForwardRef as ReactComponent };
